import React, { createContext, useState,  useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { eventDetail } from '../services/EventService'

export type Event = {
    id: number,
    createrId: number,
    title: string,
    description: string,
    summary: string,
    updatedAt: Date,
    createdAt: Date,
}

export type Store = {
    eventData: any,
    updateEvent:(data:any) => {},
};

export const StoreContext = createContext<Store>({
    eventData: {
        title: ''
    },
    updateEvent: ():any => {},
});


export const DataProvider: any = ({ children }: { children: React.ReactNode }) => {
    const [store, setStore] = useState<any>({}); 
    // const navigate = useNavigate();
 
    let { id } = useParams();
    const loadEventData = async (id:any)=>{
      try{
          if(id !== undefined && id !== null){
            const { data } = await eventDetail(Number(id))
            if(data){
              if(data.eventDetail.statusCode === 200){
                setStore({...store, eventData: data.eventDetail.data })
              }
            } 
          }
        //   else{
        //     navigate('/');
        //   }
          

      }
      catch(error){
        console.log(error)
      }
    }
    useEffect((): any=>{
        const initialize = async ()=>{
            await loadEventData(id)
        }
        initialize()
    },[])

    
    const updateStore = {
        eventData: store.eventData,
        updateEvent: (data:any):any => {
            setStore({...store, eventData: data})
        },
    } 
   
    return (
        <StoreContext.Provider value={updateStore}> 
            {children}
        </StoreContext.Provider>
    );

}

export const useStore = () => useContext(StoreContext);
